import { getNetCheckUrl } from "@/config/config";
import { detectOS, DownloadItem, FocusSDK, isFocusEnv } from "@/utils";
import NetworkCheck from "@/utils/NetworkCheck";
import { changeEgovUrl } from "@/utils/tools";
import { message } from "antd";
import { v4 } from "uuid";
import {
  checkDownloadError,
  getGlobalStatus,
  getSuccessDownloadTaskCount
} from "../../BatchDownloadPanel/BasisComponents/utils";
import {
  BatchDownloadItem,
  ErrorCode,
  GlobalStatus,
  Status,
  StatusErrorDesc
} from "../../BatchDownloadPanel/type";
import {
  convertDownloadUnit,
  createDownloadItem,
  getDocumentDownloadPath,
  getDownloadFileStatus
} from "../../BatchDownloadPanel/utils/util";
import { EventEmitter } from "events";
import { ResetErrorCode } from "@/components/Joyspace/types";

// 批量下载服务
class GroupSpaceDownloadController extends EventEmitter {
  private static instance: GroupSpaceDownloadController | null;
  private static netServer: any;
  // 初始化实例
  public static getInstance(): GroupSpaceDownloadController {
    if (!this.instance) {
      this.instance = new GroupSpaceDownloadController();
      this.instance.getPath();
    }
    // 实例化 netServer服务
    this.netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    // 初始化 isNetworkOnline
    this.instance.initNetwork();
    return this.instance;
  }
  private gid = "";
  private path = "";
  private working = false; // 标记是否有任务进行中
  private taskQueue: BatchDownloadItem[] = [];
  private currentTask: any; // 当前进行任务
  private setList: any;
  private id = 0;
  private timer: any;
  private isNetworkOnline = false;
  proxy(callback: any) {
    this.setList = callback;
  }
  getGid() {
    return this.gid;
  }
  setGid(gid = "") {
    this.gid = gid;
  }
  // start 网络初始化
  async initNetwork() {
    this.isNetworkOnline = await GroupSpaceDownloadController.netServer.checkNet();
  }
  // 获取网络状态
  getNetworkStatus() {
    return this.isNetworkOnline;
  }
  // 移除监听器
  offNetworkListener() {
    // GroupSpaceDownloadController.netServer?.off('online', () => {});
    // GroupSpaceDownloadController.netServer?.off('offline', () => {});
  }
  // 添加监听器
  // onNetworkListener() {
  //     GroupSpaceDownloadController.netServer?.on('online', function onLine() {
  //         console.log('sada=============>');
  //         // this.isNetworkOnline = true;
  //     });
  //     GroupSpaceDownloadController.netServer?.on('offline', function offline() {
  //         console.log('offline=============>');
  //         // this.isNetworkOnline = false;
  //     });
  // }
  // end
  getWorking() {
    return this.working;
  }
  checkLocalPathExist(downLocalPath: string) {
    return new Promise((resolve) => {
      if (!isFocusEnv()) {
        resolve(true);
      }
      if (!downLocalPath) {
        resolve(false);
      }
      FocusSDK.checkLocalPathExist(downLocalPath, (exists: boolean) => {
        resolve(exists);
      });
    });
  }
  // 选择下载路径
  chooseDownloadPage(callback: any) {
    FocusSDK.showOpenDialog(
      (res) => {
        // console.log('res-', res);
        this.setPath(res);
        callback?.(res);
      },
      {
        properties: ["openDirectory"],
        defaultPath: this.getPath()
      }
    );
  }
  // 获取
  getPath() {
    let config = JSON.parse(FocusSDK.getConfigData());
    const defaultPath = isFocusEnv()
      ? config.defaultJoyspaceDownloadPath ||
        FocusSDK.getJoySpaceDownloadPath() ||
        FocusSDK.getDownloadPath()
      : localStorage.getItem("defaultJoyspaceDownloadPath") || undefined;
    this.path = defaultPath;
    console.log("组空间默认下载路径===>", this.path);
    return this.path;
  }
  async setPath(path: string) {
    const isExist = await this.checkLocalPathExist(path);
    if (isExist) {
      this.path = path;
      FocusSDK.setJoySpaceDownloadPath(path);
      isFocusEnv() && FocusSDK.setConfigData("defaultJoyspaceDownloadPath", path);
      console.warn("设置下载路径", path, this.path);
      return;
    }
    message.error(StatusErrorDesc.PATH_NOT_EXIST);
  }
  async hasLocalFile(path: string, title: string): Promise<any> {
    const filePath = `${path}${detectOS() === "Win" ? "\\" : "/"}${title}`;
    return await this.checkLocalPathExist(filePath);
  }
  // 判重处理
  async getNewItem(item: BatchDownloadItem, index = 0, newTitle = item.title): Promise<any> {
    if (!isFocusEnv()) {
      return createDownloadItem(item);
    }
    this.id++;
    const hasFile = await this.hasLocalFile(item.path, newTitle);
    if (hasFile) {
      // eslint-disable-next-line no-param-reassign
      index++;
      const idx = item.title.lastIndexOf(".");
      const startStr = item.title.substring(0, idx);
      const endStr = item.title.substring(idx, item.title.length);
      // eslint-disable-next-line no-param-reassign
      newTitle = idx !== -1 ? `${startStr}(${index})${endStr}` : `${endStr}(${index})`;
      return await this.getNewItem(item, index, newTitle);
    }
    item.id = `${item.id}_${v4()}_${this.id}`;
    newTitle && (item.title = newTitle);
    return createDownloadItem(item);
  }
  // 添加任务
  async addTask(newTaskList: BatchDownloadItem[] = [], callback: () => void, options: any = {}) {
    let newList: BatchDownloadItem[] = [];
    for (let item of newTaskList) {
      item.path = this.path; //  设置文档路径
      const newItem = await this.getNewItem({ ...item });
      console.log(newItem, "newItemnewItemnewItemnewItem=====>", this.path, this.getPath());
      newList.push({ ...newItem, ...options });
    }
    this.taskQueue = this.taskQueue.concat(newList);
    console.log(this.taskQueue, "addTaskaddTaskaddTaskaddTask=====>", this.isNetworkOnline);
    callback?.();
    this.startTask(); // 开启任务
  }
  // 排序任务
  sortTask() {
    return this.getTaskQueue()
      .filter((item: any) => item.status === Status.WAITING)
      .sort((a: any, b: any) => a?.index - b?.index);
  }
  // 开始任务
  async startTask() {
    // 排序
    const sortList = this.sortTask();
    if (!sortList.length) {
      console.warn("无等待中的任务");
      return;
    }
    const item = sortList[0];
    // 校验网络
    if (!this.isNetworkOnline) {
      console.warn("网络异常");
      this.changeTask({
        ...item,
        status: item.status === Status.PROGRESS ? ErrorCode.NETWORK_ERROR : Status.CANCEL
      });
      this.startTask();
      return;
    }
    if (this.working) {
      console.warn("当前有任务进行中");
      return;
    }
    // 对文件名超多150字符直接拦截，报错.因为Electron保存会失败
    const len = item?.title?.length || 0;
    if (len > 150) {
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.changeTask({ ...item, status: ErrorCode.ERROR });
        this.startTask();
      }, 700);
      return;
    }
    // console.log(item, 'item===>');
    // 校验下载路径
    const isExist = await this.checkLocalPathExist(item.path);
    if (!isExist) {
      this.changeTask({ ...item, status: ErrorCode.PATH_NOT_EXIST });
      this.working = false;
      this.startTask();
      console.warn("下载路径不存在");
      return;
    }
    if (item.resume) {
      // this.working = true;
      // (item as any)?.cancel();
      delete item.resume;
      item.currentProgress = 0;
      item.currentSize = "0";
      this.currentTask = { ...item };
      // item.resume();
      console.warn("执行任务->重试");
      // return;
    }
    try {
      const { code, data } = await getDocumentDownloadPath(item.pageId);
      if (code !== "200") {
        switch (code) {
          case ErrorCode.FILE_DEL_ERROR:
          case ResetErrorCode.Delete:
            item.status = ErrorCode.FILE_DEL_ERROR;
            console.warn("下载的源文件不存在");
            break;
          case ErrorCode.NO_PERMISSION:
          case ResetErrorCode.noPermission:
            item.status = ErrorCode.NO_PERMISSION;
            console.warn("下载的源文件无权限");
            break;
          case ErrorCode.FILE_CHECK_PROCESS_ERROR:
            item.status = ErrorCode.FILE_CHECK_PROCESS_ERROR;
            break;
          case ErrorCode.FILE_CHECK_FAIL_ERROR:
            item.status = ErrorCode.FILE_CHECK_FAIL_ERROR;
            break;
          default:
            item.status = ErrorCode.ERROR;
        }
        this.changeTask(item);
        this.startTask();
      } else {
        console.warn("准备下载");
        this.downlaod({
          url: changeEgovUrl(data.link),
          path: item.path,
          filename: item.title,
          currentItem: { ...item }
        });
      }
    } catch (err) {
      item.status = ErrorCode.ERROR;
      this.changeTask(item);
      this.startTask();
    }
  }
  // 重写某个任务
  changeTask(newItem: BatchDownloadItem) {
    let idx = this.taskQueue.findIndex((item: BatchDownloadItem) => item.id === newItem.id);
    if (idx !== -1) {
      // const olbItem = this.taskQueue[idx];
      this.taskQueue.splice(idx, 1, { ...newItem });
    }
    // console.log('changeTask===>', this.taskQueue);
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // 修改全部等待中任务状态
  changeWaitingTaskAll(status: Status | ErrorCode) {
    this.taskQueue = this.taskQueue.map((item: BatchDownloadItem) => {
      if (item.status === Status.WAITING) {
        item.status = status;
      }
      return item;
    });
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // 修改全部的任务状态
  changeTaskAll(status: Status | ErrorCode) {
    this.taskQueue = this.taskQueue.map((item: BatchDownloadItem) => {
      item.status = status;
      return item;
    });
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // 获取任务队列
  getTaskQueue() {
    return this.taskQueue;
  }
  // 获取任务队列
  getGidByTaskQueue(gid = "") {
    return this.taskQueue.filter((item) => item.gid === gid);
  }
  // 获取等待中和进行中
  getProgressTask() {
    return this.taskQueue.filter((item: any) => item.status === Status.WAITING);
  }
  // 清空任务
  clearTaskAll() {
    const item: any = this.taskQueue.find(
      (item: BatchDownloadItem) => item.status === Status.PROGRESS
    );
    this.currentTask = null;
    this.taskQueue = []; // 置空任务队列
    this.working = false;
    this.id = 0;
    item?.cancel();
    this.offNetworkListener();
  }
  clearGidByTask(gid = "") {
    const item: any = this.taskQueue.find(
      (item: BatchDownloadItem) => item.status === Status.PROGRESS && item.gid === gid
    );
    this.currentTask?.gid === gid && (this.currentTask = null);
    // this.taskQueue = []; // 置空任务队列
    this.taskQueue = this.taskQueue.filter((item: BatchDownloadItem) => item.gid !== gid);
    item && (this.working = false);
    !this.taskQueue.length && (this.id = 0); // 排序值
    item?.cancel();
    this.offNetworkListener();
    this.emit("group-download-control-event", []);
  }
  // 执行下载
  downlaod({
    url,
    path,
    filename,
    currentItem
  }: {
    url: string;
    path: string;
    filename: string;
    currentItem: BatchDownloadItem;
  }) {
    if (!this.working) {
      this.working = true;
      console.warn("开始下载");
      let flag = false; // 用于区分用户是手动触发，还是downloadFile触发的
      return new Promise((resolve, reject) => {
        let resumeLimitCount = 0;
        try {
          FocusSDK.downloadFile(url, {
            saveAs: false, // 是否另存为
            viewFile: false, // 预览文件
            defaultPath: path, // 下载路径
            filename, // 文件名称
            alreadySaveAs: false, // 本地是否已存在
            onStarted: (downloadItem: DownloadItem) => {
              this.objectAssignTask({ ...currentItem, ...downloadItem });
              this.changeTask(this.currentTask);
              console.log("onStarted==>", downloadItem, this.currentTask);
            },
            onProgress: async (progress: any) => {
              console.log("onProgress1==>", progress);
              if (!this.isNetworkOnline) {
                flag = true;
                this.currentTask.cancel();
                return;
              }
              if (progress.totalBytes === 0 && progress.status === "interrupted") {
                const code = await getDownloadFileStatus(url);
                console.log(code, "codecodecodecodecodecodecodecodecode");
                if (code === 506) {
                  message.error("当前下载人数较多，请稍后重试");
                  this.currentTask?.cancel();
                  this.objectAssignTask({
                    status: !this.isNetworkOnline ? ErrorCode.NETWORK_ERROR : Status.CANCEL
                  });
                  this.changeTask(this.currentTask);
                  this.working = false;
                  this.startTask();
                  reject(new Error("download 506"));
                }
              }
              if (progress.status === "interrupted") {
                if (resumeLimitCount >= 5) {
                  console.warn("开始重试--重试次数-->", resumeLimitCount);
                  this.objectAssignTask({
                    status: ErrorCode.ERROR
                  });
                  this.changeTask(this.currentTask);
                  this.working = false;
                  this.startTask();
                  reject(new Error("超出resume重试次数"));
                } else if (this.currentTask.resume) {
                  resumeLimitCount++;
                  this.currentTask?.resume();
                }
                return;
              }
              this.objectAssignTask({
                status: Status.PROGRESS,
                currentProgress: Number(progress.percent),
                size: convertDownloadUnit(progress.totalBytes),
                currentSize: convertDownloadUnit(progress.transferredBytes)
              });
              this.changeTask(this.currentTask);
              console.log("onProgress2==>", progress, this.currentTask);
            },
            onCancel: () => {
              if (!this.taskQueue.length) {
                return;
              } else if (resumeLimitCount >= 5) {
                this.objectAssignTask({
                  status: ErrorCode.ERROR
                });
                if (this.currentTask.resume) {
                  delete this.currentTask.resume;
                  delete this.currentTask.pause;
                  delete this.currentTask.cancel;
                }
              } else if (flag && this.currentTask.status === Status.PROGRESS) {
                flag = false;
                this.objectAssignTask({
                  status: ErrorCode.NETWORK_ERROR
                });
              } else {
                this.objectAssignTask({
                  status: Status.CANCEL
                });
              }

              this.currentTask.currentProgress = 0;
              this.currentTask.currentSize = "0";
              this.changeTask(this.currentTask);
              this.working = false;
              this.startTask();
              console.log("触发了取消");
              console.log("onCancel==>", this.currentTask);
              // reject(new Error('cancel'));
            },
            onPause: () => {
              this.currentTask?.cancel();
              console.log("触发了暂停");
              console.log("onPause==>", this.currentTask);
            },
            onResume: () => {
              if (!this.working) {
                this.startTask();
              }
              console.log("我点击了重试");
              console.log("onResume==>", this.currentTask);
            },
            onFinish: (files, data) => {
              console.warn("下载成功");
              this.objectAssignTask({
                status: Status.SUCCESS
              });
              this.changeTask(this.currentTask);
              this.working = false;
              this.startTask();
              console.log("onFinish==>", this.currentTask);
              resolve(data);
            },
            onError: async (error) => {
              console.log(error, "==========>");
              console.warn("下载异常");
              let status = ErrorCode.ERROR;
              if (!this.isNetworkOnline) {
                status = ErrorCode.NETWORK_ERROR;
              }
              const isExist = await this.checkLocalPathExist(currentItem.path);
              if (!isExist) {
                status = ErrorCode.PATH_NOT_EXIST;
              }

              this.objectAssignTask({
                ...currentItem,
                status
              });
              delete this.currentTask?.resume;
              delete this.currentTask?.pause;
              delete this.currentTask?.cancel;
              this.currentTask.currentProgress = 0;
              this.currentTask.currentSize = "0";
              this.changeTask(this.currentTask);
              this.working = false;
              this.startTask();
              console.log("onError==>", this.currentTask);
              // reject(new Error(JSON.stringify({ error })));
            }
          });
        } catch (e) {
          reject(e);
          console.log("catch error", e);
          this.objectAssignTask({
            ...currentItem,
            status: ErrorCode.ERROR
          });
          this.changeTask(this.currentTask);
          console.log("catchonError==>", this.currentTask);
        }
      });
    }
  }
  objectAssignTask(options: any) {
    this.currentTask = { ...this.currentTask, ...options };
  }
  // 异常处理 start
  // 无网络处理
  handleNetwrokByList() {
    this.taskQueue = this.taskQueue.map((item: BatchDownloadItem) => {
      if (item.status === Status.WAITING) {
        item.status = Status.CANCEL;
      } else if (item.status === Status.PROGRESS) {
        (item as any)?.cancel();
        item.status = ErrorCode.NETWORK_ERROR;
      } else if (item.status === Status.CANCEL || item.status === Status.RETRY) {
        item.status = ErrorCode.NETWORK_ERROR;
      }
      return item;
    });
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // end
  // 全部重试
  handleTaskRetryAll(gid: any) {
    for (let item of this.taskQueue) {
      if (item.gid === gid) {
        if (!this.isNetworkOnline && item.status !== Status.SUCCESS) {
          // item.status === Status.PROGRESS && item.pause && item.pause();
          item.status = ErrorCode.NETWORK_ERROR;
        } else if (
          checkDownloadError(item.status as ErrorCode) ||
          item.status === Status.CANCEL ||
          item.status === Status.RETRY
        ) {
          item.status = Status.WAITING;
        }
      }
    }
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
    this.isNetworkOnline && !this.working && this.startTask();
  }
  // 全部取消
  handleTaskCancelAll(gid: any) {
    for (let item of this.taskQueue) {
      if (item.gid === gid) {
        if (item.status === Status.WAITING) {
          item.status = Status.CANCEL;
        } else if (item.status === Status.PROGRESS) {
          item.cancel && item.cancel();
        }
      }
    }
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  getGidByStateInfo(gid = "") {
    let downlaodInfo = { status: GlobalStatus.SUCCESS_ALL, currentCount: 0, totalCount: 0 };
    if (!gid) {
      return downlaodInfo;
    }
    let taskList = this.taskQueue.filter((item: BatchDownloadItem) => item.gid === gid);
    downlaodInfo.status = getGlobalStatus(taskList);
    downlaodInfo.currentCount = getSuccessDownloadTaskCount(taskList);
    downlaodInfo.totalCount = taskList.length;
    return downlaodInfo;
  }
}

export default GroupSpaceDownloadController;
